<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">

      <!-- Edición del Estado -->
      <p-panel header="{{ 'ESTADOS.LBL_ESTADOS' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCanales" name="fCanales">
          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!estado">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="20"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'CANALES.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'CANALES.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="estado && estado.idEstado">
                  <label class="falso-combo-texto">{{estado.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="100"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'ESTADOS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_TIPOPRODUCTO' | translate }}</label>
                <p-multiSelect id="idsTiposProducto" name="idsTiposProducto" [options]="lisTiposProducto"
                               styleClass="w-full"
                               defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                               selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                               formControlName="idsTiposProducto"
                               emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               optionValue="value"
                               optionLabel="label"
                ></p-multiSelect>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsTiposProducto.invalid">
                  {{ 'ESTADOS.LBL_TIPOPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_ESTADOINICIAL' | translate}}" binary="true"
                          id="idIndicadorInicial"
                          name="nomIndicadorInicial" (onChange)="cambioIndicadorEstados($event, true)"
                          formControlName="indicadorEstadoInicial"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_ESTADOFINAL' | translate}}" binary="true"
                          id="idIndicadorFinal"
                          name="nomIndicadorFinal" (onChange)="cambioIndicadorEstados($event, false)"
                          formControlName="indicadorEstadoFinal"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_FABRICACREDITO' | translate}}" binary="true"
                          id="indicadorFabricaCredito"
                          name="indicadorFabricaCredito" (onChange)="checkUnicoBloqueoFabrica($event, true)"
                          formControlName="indicadorFabricaCredito"></p-checkbox>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_ESTADOAPROBADO' | translate}}" binary="true"
                          id="idIndicadorAprobado"
                          name="nomIndicadorAprobado"
                          formControlName="indicadorAprobado"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_CANCELA' | translate}}" binary="true"
                          id="idIndicadorCancela"
                          name="nomIndicadorCancela"
                          formControlName="indicadorCancela"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_UNIDADCREDITO' | translate}}" binary="true"
                          id="idIndicadorUnidadCredito"
                          name="nomIndicadorUnidadCredito"
                          formControlName="indicadorUnidadCredito"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_CHECKDOCUMENTAL' | translate}}" binary="true"
                          id="idIndicadorCheckDocumental"
                          name="nomIndicadorCheckDocumental"
                          formControlName="indicadorCheckDocumental"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_INDICADORCOMITE' | translate}}" binary="true"
                          id="idIndicadorComite"
                          name="nomIndicadorComite"
                          formControlName="indicadorComite"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_ESTADODESEMBOLSO' | translate}}" binary="true"
                          id="idIndicadorDesembolso"
                          name="nomIndicadorDesembolso"
                          formControlName="indicadorDesembolso"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_ESTADOPERFILAMOS' | translate}}" binary="true"
                          id="idIndicadorPerfilado"
                          name="nomIndicadorPerfilado"
                          formControlName="indicadorPerfilado"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_INDICADORVISITA' | translate}}" binary="true"
                          id="indicadorVisita"
                          name="noIndicadorVisita"
                          formControlName="indicadorVisita"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_ALIADO' | translate}}" binary="true"
                          id="idIndicadorAliado"
                          name="nomIndicadorAliado"
                          formControlName="indicadorAliado"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_BLOQUEADO' | translate}}" binary="true"
                          id="idIndicadorBloqueado"
                          name="nomIndicadorBloqueado"
                          formControlName="indicadorBloqueado"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_BLOQUEADOSARLAFT' | translate}}" binary="true"
                          id="indicadorBloqueadoSarlaft"
                          name="indicadorBloqueadoSarlaft" (onChange)="checkUnicoBloqueoFabrica($event, false)"
                          formControlName="indicadorBloqueadoSarlaft"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_CALIFICARREFERENCIAS' | translate}}" binary="true"
                          id="idIndicadorCalificarReferencias"
                          name="nomIndicadorCalificarReferencias"
                          formControlName="indicadorCalificarReferencias"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'ESTADOS.LBL_MOSTRARCLIENTE' | translate}}" binary="true"
                          id="indicadorMostrarCliente"
                          name="indicadorMostrarCliente"
                          formControlName="indicadorMostrarCliente"></p-checkbox>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <img *ngIf="!carImagen && imagen" style="height: 100px" [src]="imagen" alt=""/>
              <div *ngIf="f.idAdjunto.value && !carImagen" class="btn-group" role="group" style="display: block;">
                <label class="btn btn-default" style="max-width: 87%; overflow: hidden;">
                  <i class="fa fa-file-o" aria-hidden="true"></i>
                  {{nomArchivo}}
                </label>
                <a class="btn btn-danger" (click)="cancelarAdjunto()" style="padding: 3px; border-radius: 5px;">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
              </div>
              <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                            chooseLabel="{{'ESTADOS.LBL_ADJUNTARICONO' | translate}}" #adjunto
                            (onBeforeUpload)="onBeforeSend($event)" mode="basic" [hidden]="carImagen"
                            (onValidSelect)="onSelect($event, $event.files)"
                            invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                            invalidFileTypeMessageDetail="{{'SEGMENTOS.LBL_FILETIPOES' | translate}}"
                            (onUpload)="onUpload($event)" accept="image/*" fSize
              ></p-fileUpload>
              <div *ngIf="carImagen">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_CARGANDO' | translate }}</span>
              </div>
            </div>
          </div>


          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="confirmar-check">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
